class ClientDashboardController {
  constructor() {
    this.name = 'clientDashboard';
    this.percentage = 30;
    this.notificationHidden = false;

    this.errorSectionOpened = [];

    this.breadcrumbsItems = [{
        label: 'Dashboard',
        isCurrent: true,
    }];

    this.masterDataTabs = [{
      id: 'tab-1',
      tabLabel: 'Employees',    
    },{
      id: 'tab-2',
      tabLabel: 'Records',
    }];
    
    this.listItemHeading = 'Notifications';

    this.notificationsData =  [
    {
      title: 'Singapore',
      hasErrors: false,
      date: 1510704000,
      hour: -2211690600,
      id: 0,
      count: 4
    },
    
    {
      title: 'Japan',
      hasErrors: true,
      date: 1510704000,
      hour: -2211690600,
      id: 1,
      count: 8
    },
    {
      title: 'UK',
      hasErrors: false,
      date: 1510704000,
      hour: -2211690600,
      id: 2,
      count: 7
    },
    {
      title: 'Egypt',
      hasErrors: false,
      date: 1510704000,
      hour: -2211690600,
      id: 3,
      count: 4
    }];

    this.mainNavItems = [{
      label: 'Dashboard'
    }, {
      label: 'Executive Summary'
    }, {
      label: 'Training'
    }, {
      label: 'Help'
    }];

    this.userProfileItems = [{
      label: 'Settings'
    }, {
      label: 'Log out'
    }];

    this.periodItems = [{
      date: 1,
      type: 'pin',
      color: 'pink',
      tip: 'Lorem ipsum dolor sin'
    }, {
      date: 5,
      type: 'dot',
      color: 'green',
      tip: 'Lorem ipsum dolor sin'
    }, {
      date: 7,
      type: 'dot',
      color: 'red',
      tip: 'Lorem ipsum dolor sin'
    }, {
      date: 17,
      type: 'dot',
      color: 'empty',
      tip: 'Lorem ipsum dolor sin'
    }, {
      date: 20,
      type: 'pin',
      color: 'purple',
      tip: 'Lorem ipsum dolor sin'
    }, {
      date: 30,
      type: 'pin',
      color: 'green',
      tip: 'Lorem ipsum dolor sin'
    }];

    this.timelineContextualMenuItems = [{
      type: 'checkbox',
      icon: 'pay-date',
      color: 'green',
      label: 'Pay Dates'
    }, {
      type: 'checkbox',
      icon: 'cut-off-date',
      color: 'purple',
      label: 'Cut-off Days'
    }, {
      type: 'checkbox',
      icon: 'success',
      label: 'Successful Sync Points'
    }, {
      type: 'checkbox',
      icon: 'error',
      label: 'Failed Sync Points'
    }, {
      type: 'checkbox',
      icon: 'circle',
      label: 'Upcoming Sync Points'
    }, {
      type: 'checkbox',
      icon: 'menu-icon locked-period',
      label: 'Locked period'
    }];

    this.allErrorsDropdown = [{
        label: 'All Errors',
        icon: ''
      }, {
        label: 'Payroll Blockers',
        icon: 'flag'
      }, {
        label: 'Confirguration',
        icon: ''
      }, {
        label: 'Data',
        icon: ''
      }, {
        label: 'Informational',
        icon: ''
      }, {
        label: 'Process',
        icon: ''
    }];
    

    this.dataCompositionLegendTab1 = [{
      color: '0c900c',
      label: 'Successful',
      count: '1500',
    }, {
      color: '4a4a4a',
      label: 'Ignored',
      count: '200',
    }, {
      color: 'd40f0f',
      label: 'Failed',
      count: '34',
      }];

    this.dataCompositionLegendTab2 = [{
      color: '0c900c',
      label: 'Successful',
      count: '10',
    }, {
      color: '4a4a4a',
      label: 'Ignored',
      count: '2',
    }, {
      color: 'd40f0f',
      label: 'Failed',
      count: '4',
      }];

    this.cycles = [{
          title: 27,
          disabled: true,
          pin: 'purple',
          month: 'Oct'
      }, {
          title: 28,
          disabled: true,
          month: 'Oct'
      }, {
          title: 29,
          disabled: true,
          month: 'Oct'
      }, {
          title: 30,
          disabled: true,
          month: 'Oct'
      }, {
          title: 31,
          disabled: true,
          month: 'Oct'
      }, {
          title: 1,
          disabled: false,
          status: 'success',
          start: true,
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 2,
          disabled: false,
          current: true,
          month: 'Nov'
      }, {
          title: 3,
          disabled: false,
          status: 'error',
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 4,
          disabled: false,
          month: 'Nov'
      }, {
          title: 5,
          disabled: false,
          month: 'Nov'
      }, {
          title: 6,
          disabled: false,
          month: 'Nov'
      }, {
          title: 7,
          disabled: false,
          month: 'Nov'
      }, {
          title: 8,
          disabled: false,
          month: 'Nov'
      }, {
          title: 9,
          disabled: false,
          month: 'Nov'
      }, {
          title: 10,
          disabled: false,
          status: 'error',
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 11,
          disabled: false,
          today: true,
          month: 'Nov'
      }, {
          title: 12,
          disabled: false,
          month: 'Nov'
      }, {
          title: 13,
          disabled: false,
          month: 'Nov'
      }, {
          title: 14,
          disabled: false,
          month: 'Nov'
      }, {
          title: 15,
          disabled: false,
          month: 'Nov'
      }, {
          title: 16,
          disabled: false,
          month: 'Nov'
      }, {
          title: 17,
          disabled: false,
          icon: 'circle',
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 18,
          disabled: false,
          month: 'Nov'
      }, {
          title: 19,
          disabled: false,
          month: 'Nov'
      }, {
          title: 20,
          disabled: false,
          month: 'Nov'
      }, {
          title: 21,
          disabled: false,
          month: 'Nov'
      }, {
          title: 22,
          disabled: false,
          month: 'Nov'
      }, {
          title: 23,
          disabled: false,
          month: 'Nov'
      }, {
          title: 24,
          disabled: false,
          icon: 'circle',
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 25,
          disabled: false,
          pin: 'purple',
          description: 'Lorem ipsum dolor sin',
          cycleStart: true,
          month: 'Nov'
      }, {
          title: 26,
          disabled: false,
          month: 'Nov'
      }, {
          title: 27,
          disabled: false,
          month: 'Nov'
      }, {
          title: 28,
          disabled: false,
          pin: 'green',
          cycleEnd: true,
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 29,
          disabled: false,
          icon: 'circle',
          month: 'Nov'
      }, {
          title: 30,
          disabled: false,
          icon: 'circle',
          end: true,
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }];

    this.donutData = [{
      params: {
        size: {
          width: 260,
          height: 260
        },
        legend: {
          show: false 
        },
        data: {
            colors: {
              'Successful': '#0c900c',
              'Ignored': '#4a4a4a',
              'Failed': '#d40f0f'
            },
            columns: [
                ['Successful', 1500],
                ['Ignored', 200],
                ['Failed', 34]
            ],
            type : 'donut'
        },
        donut: {
          width:30,
          label: {
            show: false
          }
        }
      },
      text: {
        value: '234 / 1734',
        label: 'Failed Employee Data',
      },
      hasBackground: true,
      background: {
        width: 260,
        height: 260, 
        cx: 130,
        cy: 128,
        r: 102,
        stroke: 'rgba(216, 216, 216, 0.6)',
        strokeWidth: 44,
      }
    }, {
      params: {
        size: {
          width: 260,
          height: 260
        },
        legend: {
          show: false 
        },
        data: {
            colors: {
              'Successful': '#0c900c',
              'Ignored': '#4a4a4a',
              'Failed': '#d40f0f'
            },
            columns: [
                ['Successful', 10],
                ['Ignored', 2],
                ['Failed', 4]
            ],
            type : 'donut'
        },
        donut: {
          width:30,
          label: {
            show: false
          }
        }
      },
      text: {
        value: '16',
        label: 'Records synchronized',
      },
      hasBackground: true,
      background: {
        width: 260,
        height: 260, 
        cx: 130,
        cy: 128,
        r: 102,
        stroke: 'rgba(216, 216, 216, 0.6)',
        strokeWidth: 44,
      }
    }];

    this.dropdownTabs = [{
      title: 'Country',
      content: [{name: 'Egypt', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: true},
                {name: 'Finland', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Hungary', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Jamaica', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Japan', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Luxemburg', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'New Zealand', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Poland', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'United Arab Emirates', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'United Kingdom', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Sweden', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Urugai', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false}],
      selectedValue: 'Egypt',
      open: false,

      }, {
      title: 'Company',
      content: [{name: 'Bombastic Beverage Co.', value: ''},
                {name: 'Devlish Designs', value: ''},
                {name: 'Fantastic Fashion', value: ''}],
      selectedValue: 'Devlish Designs',
      open: false,
      }, {
      title: 'Paygroup',
      content: [{name: 'Executives', value: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad illum in delectus modi laboriosam.'},
                {name: 'Part-time Employees', value: ' Itaque ipsam cum nobis sunt laborum, aspernatur velit enim porro facilis eligendi.'},
                {name: 'Regular Employees', value: ', odit consequatur laudantium repudiandae'}],
      selectedValue: 'Regular Employees',
      open: false,
    }];
  }

  popTableSection(index) {
    var index = parseInt(index);
    this.errorSectionOpened[index] = !this.errorSectionOpened[index];
  }

  tabsOpened() {
    this.dropDownOpened = true;
  }
  
  tabsClosed() {
    this.dropDownOpened = false;
  }

  selectDropdownItem (e, item) {
    event.preventDefault();
    event.stopPropagation();

    this.item = item;
    let index = undefined;

    switch(this.item.title) {
      case "Country":
        index = 0;
        break;
      case "Company":
        index = 1;
        break;
      case "Paygroup":
        index = 3;
        break;
      default:
        index = 0;
    }

    this.liIsSelected = this.item.isSelected;

    if (this.liIsSelected) {
      this.dropdownTabs[index].content.forEach(li => li.isSelected = false);

    } else {
      this.dropdownTabs[index].content.forEach(li => li.isSelected = false);
      this.liIsSelected = !this.liIsSelected;
    }
    
    this.item.isSelected = this.liIsSelected;
  }
}

export
default ClientDashboardController;



// WEBPACK FOOTER //
// ./src/app/pages/clientDashboard/clientDashboard.controller.js